var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationProvider", {
    ref: "datePickerValidator",
    attrs: {
      rules: _vm.validatorRules,
      name: _vm.validatorName,
      vid: _vm.$attrs.id,
      tag: "div",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c(
              "div",
              {
                class: [
                  { "error-styles": errors[0] },
                  { "disabled-field": _vm.disabled },
                  { "hidden-field": _vm.hidden },
                  "lf-datepicker-container",
                ],
              },
              [
                _c("div", { staticClass: "label-container" }, [
                  _c(
                    "span",
                    {
                      class: [
                        { "required-field": _vm.requiredField },
                        "label-text",
                      ],
                    },
                    [_vm._v(_vm._s(_vm.label))]
                  ),
                  _vm.showInfo
                    ? _c("span", { class: [_vm.icons.info, "label-icon"] })
                    : _vm._e(),
                ]),
                _c("ejs-datepicker", {
                  ref: "datePicker",
                  staticClass: "lf-datepicker",
                  attrs: {
                    value: _vm.innerValue,
                    id: _vm.id,
                    name: _vm.id,
                    placeholder: "dd/mm/aaaa",
                    change: _vm.onValueChange,
                    format: "dd/MM/yyyy",
                    cleared: _vm.clearField,
                    focus: _vm.onFocus,
                    showClearButton: true,
                    strictMode: true,
                    created: _vm.onDatePickerCreated,
                    destroyed: _vm.onDatePickerDestroyed,
                    open: _vm.onDatePickerOpen,
                    close: _vm.onDatePickerClose,
                  },
                  model: {
                    value: _vm.innerValue,
                    callback: function ($$v) {
                      _vm.innerValue = $$v
                    },
                    expression: "innerValue",
                  },
                }),
                _c("div", { staticClass: "messages-container" }, [
                  errors.length
                    ? _c("span", { staticClass: "alert-message" }, [
                        _vm._v(_vm._s(errors[0])),
                      ])
                    : _c("span", { staticClass: "help-message" }, [
                        _vm._v(_vm._s(_vm.helpText)),
                      ]),
                ]),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }